export default {
  data () {
    return {
      pendingAdminRetry: null,
      sessionCountdown: 0,
      sessionTimer: null,
      showLogoutModal: false,
      showAdminSessionModal: false
    }
  },
  computed: {
    formattedCountdown () {
      const s = Math.max(0, this.sessionCountdown)
      return `${Math.floor(s / 60)}:${(s % 60).toString().padStart(2, '0')}`
    }
  },
  beforeDestroy () {
    this.clearSessionTimer()
  },
  methods: {
    decodeJWT (token) {
      try {
        const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
        return JSON.parse(atob(base64))
      } catch { return null }
    },
    startSessionTimer () {
      this.clearSessionTimer()
      const token = localStorage.getItem('adminToken')
      if (!token) return
      const payload = this.decodeJWT(token)
      if (!payload?.exp) return
      const secondsLeft = payload.exp - Math.floor(Date.now() / 1000)
      if (secondsLeft <= 0) { this.showAdminSessionModal = true; return }
      this.sessionCountdown = secondsLeft
      this.sessionTimer = setInterval(() => {
        this.sessionCountdown--
        if (this.sessionCountdown <= 0) { this.clearSessionTimer(); this.showAdminSessionModal = true }
      }, 1000)
    },
    clearSessionTimer () {
      if (this.sessionTimer) { clearInterval(this.sessionTimer); this.sessionTimer = null }
    },
    openLogoutModal () {
      this.showLogoutModal = false
      this.$nextTick(() => { this.showLogoutModal = true })
    },
    closeLogoutModal () {
      this.showLogoutModal = false
      document.body.style.overflow = ''
    },
    confirmLogout () {
      this.showLogoutModal = false
      this.adminLogout()
    },
    async adminLogout () {
      this.clearSessionTimer()
      try {
        const token = localStorage.getItem('adminToken')
        const refreshToken = localStorage.getItem('adminRefreshToken')
        await fetch('https://tyng-ca.com.my/api/admin/logout.php', {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({ refresh_token: refreshToken })
        })
      } catch (err) { console.error('Admin logout error:', err) }
      localStorage.removeItem('adminToken')
      localStorage.removeItem('adminRefreshToken')
      localStorage.removeItem('adminRole')
      this.$router.push({ name: 'Admin-Login', params: { lang: this.$i18n.locale } })
    },
    isValidEmailFormat (email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    },
    isValidDateOfBirth (dateString) {
      const match = dateString.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
      if (!match) return false
      const [, dd, mm, yyyy] = match
      const d = new Date(+yyyy, +mm - 1, +dd)
      return d.getFullYear() === +yyyy && d.getMonth() === +mm - 1 && d.getDate() === +dd
    },
    async adminFetch (url, options = {}) {
      const fullUrl = url.startsWith('http') ? url : `https://tyng-ca.com.my${url}`
      const token = localStorage.getItem('adminToken')
      const res = await fetch(fullUrl, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          ...(options.headers || {})
        }
      })
      if (res.status === 401) { this.clearSessionTimer(); this.showAdminSessionModal = true; return null }
      const data = await res.json()
      if (!res.ok) throw new Error(data.message || 'Request failed')
      return data
    },
    async continueAdminSession () {
      const refreshToken = localStorage.getItem('adminRefreshToken')
      if (!refreshToken) { this.showAdminSessionModal = false; this.adminLogout(); return }
      try {
        const res = await fetch('https://tyng-ca.com.my/api/admin/refresh-token.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refresh_token: refreshToken })
        })
        const data = await res.json()
        if (data.success) {
          localStorage.setItem('adminToken', data.token)
          if (data.refresh_token) localStorage.setItem('adminRefreshToken', data.refresh_token)
          const payload = this.decodeJWT(data.token)
          if (payload?.role) localStorage.setItem('adminRole', payload.role)
          this.showAdminSessionModal = false
          this.startSessionTimer()
          if (this.pendingAdminRetry) {
            const retry = this.pendingAdminRetry
            this.pendingAdminRetry = null
            await retry()
          }
        } else { this.showAdminSessionModal = false; this.adminLogout() }
      } catch (err) {
        console.error('Admin session refresh failed:', err)
        this.showAdminSessionModal = false
        this.adminLogout()
      }
    },
    signOutAdminSession () {
      this.showAdminSessionModal = false
      this.pendingAdminRetry = null
      this.adminLogout()
    }
  }
}
